var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable import/extensions */
import { Component, Vue, } from 'vue-property-decorator';
import TheNavbar from './components/TheNavbar.vue';
import TheFooter from './components/TheFooter.vue';
import AlertMessage from './components/AlertMessage.vue';
import authService from './services/auth';
// TODO: Move to service, use App.vue to observe and route.
/* eslint-disable class-methods-use-this */
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.forceRender = 1;
        _this.authObserver = null;
        return _this;
    }
    App.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.authObserver = authService.observeAuth()
                    .subscribe(function (currentUser) { return __awaiter(_this, void 0, void 0, function () {
                    var route, noAuthRoutes;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                route = this.$router.currentRoute.name;
                                console.log("Auth event, current route: ".concat(route, ", current user: ").concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid));
                                console.log("Auth event, current user isAnonymous(): ".concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous));
                                if (!route) {
                                    console.warn("No route, route == ".concat(route));
                                    return [2 /*return*/];
                                }
                                if (currentUser && !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous)) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, authService.signinWithStoredToken()];
                            case 1:
                                // We'll try to login with existing auth token (if we have any).
                                // If that fails, we either:
                                //
                                // 1. Do nothing (if route does not require authentication).
                                // 2. Redirect to login page (if route requires authentication).
                                if (_a.sent()) {
                                    console.log('Signed in with stored token');
                                    authService.forceAuthEmit(null);
                                    // Authentication success with existing credentials.
                                    //
                                    // Force re-render of this page to reload any data that
                                    // previously failed due to no authentication.
                                    // this.forceRender += 1;
                                    return [2 /*return*/];
                                }
                                console.log('Did not sign in with stored token');
                                noAuthRoutes = ['login', 'LandingPage', 'election'];
                                if (noAuthRoutes.includes(route)) {
                                    console.log('Not logged in, but no login required.');
                                    return [2 /*return*/];
                                }
                                console.log('Login required. Redirecting to login page.');
                                this.$router.push({ name: 'login' });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    App = __decorate([
        Component({
            components: {
                TheNavbar: TheNavbar,
                AlertMessage: AlertMessage,
                TheFooter: TheFooter,
            },
        })
    ], App);
    return App;
}(Vue));
export default App;
